import { render, staticRenderFns } from "./UserButtons.vue?vue&type=template&id=2013ad78&scoped=true"
import script from "./UserButtons.vue?vue&type=script&lang=js"
export * from "./UserButtons.vue?vue&type=script&lang=js"
import style0 from "./UserButtons.vue?vue&type=style&index=0&id=2013ad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013ad78",
  null
  
)

export default component.exports